import { map } from "lodash";
import { z } from "zod";

// Characters per line at ESC/POS font A, per paper width. The Rust renderer
// lays the receipt out in character cells, so the mm-to-columns mapping lives
// here next to the list of sizes the picker offers.
const pageSizeColumns: Record<string, number> = {
	"80mm": 48,
	"78mm": 48,
	"76mm": 42,
	"58mm": 32,
	"57mm": 32,
	"44mm": 24,
};

const DEFAULT_COLUMNS = 48;

export const columnsForPageSize = (pageSize?: string) =>
	(pageSize && pageSizeColumns[pageSize]) || DEFAULT_COLUMNS;

export const printTestData: ReceiptLine[] = [
	{ kind: "text", text: "Titre", align: "center", bold: true, size: 2 },
	{ kind: "text", text: "Description", align: "center" },
	{ kind: "feed", lines: 1 },
	{ kind: "barcode", value: "023456789010" },
	{ kind: "feed", lines: 3 },
	{ kind: "cut" },
];

export const pageSizeOptions = map(Object.keys(pageSizeColumns), (value) => ({
	value,
	label: value,
}));

export const settingsSchema = z.object({
	defaultVatRateId: z.string().optional(),
	name: z.string().min(1),
	pageSize: z.enum(map(pageSizeOptions, (option) => option.value) as any),
});

export type settingsSchemaType = z.infer<typeof settingsSchema>;
